import { Card, Stack, Typography, Switch, ToggleButtonGroup, ToggleButton, Button } from "@mui/material";
import { SHOW_TYPES } from "Constants/Survey";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import {
  toggleVisibility as toggleMarginPark,
  togglePointwiseShow,
  changeTrafficShowType,
  clearSelectedZones,
} from "Redux/marginParkSlice";
import {
  changeHeatMap2Mode,
  SelectingType,
  ColorStepType,
  toggleVisibility as toggleZones,
  changeHeatMap2ColorStep,
  toggleShowHeatMap2Numbers,
  changeApplySelected,
} from "Redux/zonesSlice";
import { createTrafficAnalysisStarUrl } from "Redux/starSlice";
import { useState } from "react";

export default function MarginPark() {
  const dispatch = useAppDispatch();

  const { marginParkShowType, visible, pointwiseShow } = useAppSelector((state) => state.marginPark);
  const { colorStep, showHeatMap2Numbers } = useAppSelector((state) => state.zones);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleSurveyShowType = (event: React.MouseEvent<HTMLElement>, newMode: SelectingType) => {
    if (newMode !== null) {
      dispatch(changeTrafficShowType(Number(newMode)));
    }
  };

  const SPECTRUM_NUMBERS = [1200, 800, 400, 240, 120];

  const handleShowHeatMap2Numbers = () => {
    dispatch(toggleShowHeatMap2Numbers());
  };

  const handleMarkerPointWise = () => {
    dispatch(togglePointwiseShow());
  };

  const handleheatMap2Step = (event: React.MouseEvent<HTMLElement>, step: ColorStepType) => {
    if (step !== null) {
      dispatch(changeHeatMap2ColorStep(step));
    }
  };

  const handleSwitch = () => {
    dispatch(toggleMarginPark());
    dispatch(clearSelectedZones());
    dispatch(
      createTrafficAnalysisStarUrl([
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=558b06a0-6092-44e0-ba4d-3d2e8686ed76`,
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=ba043ce2-7628-4e8f-acfa-81add55910a0`,
      ])
    );
  };

  const handleOptions = () => {
    if (marginParkShowType === 0) {
      return (
        <Stack direction="row" sx={{ justifyContent: "space-between" }}>
          <Button onClick={handleMarkerPointWise} variant={pointwiseShow ? "contained" : "light"} style={{ marginRight: "10px" }}>
            نمایش نقطه ای
          </Button>
        </Stack>
      );
    }
    if (marginParkShowType === 2) {
      return (
        <Stack direction="row">
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <Button onClick={handleShowHeatMap2Numbers} variant={showHeatMap2Numbers ? "contained" : "light"} sx={{ mx: "10px" }}>
              نمایش اعداد
            </Button>
          </Stack>
          <Stack>
            <ToggleButtonGroup value={colorStep} exclusive onChange={handleheatMap2Step} aria-label="text alignment">
              {SPECTRUM_NUMBERS.map((s, index) => (
                <ToggleButton
                  className="fa-number"
                  value={index + 1}
                  aria-label={`top-${s}`}
                  style={{
                    width: "56px",
                    height: "56px",
                    backgroundColor: colorStep === index + 1 ? "#4754CA" : "",
                    color: colorStep === index + 1 ? "#fff" : "",
                  }}
                >
                  طیف {s}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Stack>
        </Stack>
      );
    }
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row">
        {handleOptions()}
        <ToggleButtonGroup
          value={Number(marginParkShowType)}
          onChange={handleSurveyShowType}
          exclusive
          aria-label="traffic-show-type"
        >
          {SHOW_TYPES.map((t, index) => (
            <ToggleButton
              value={index}
              aria-label={`traffic-mode-${index}`}
              style={{
                width: "80px",
                height: "56px",
                backgroundColor: Number(marginParkShowType) === index ? "#4754CA" : "",
                color: Number(marginParkShowType) === index ? "#fff" : "",
              }}
            >
              {t}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleSwitch} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
